import { ReactElement } from 'react';
import Modal from '@components/Modal';
import { getLabelFallback } from '@utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '@redux-actions/';
import { useNavigate, useLocation } from 'react-router';

const SessionModal = () : ReactElement => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();

    const cartPageUrl = useSelector(state => state.cart.config.pagesUrl.cart);

    const clickButton = () => {
        dispatch(actions.setShowSessionModal(false));
        dispatch(actions.startLoading());
        navigate(cartPageUrl + search);
    }

    const close = () => {
        dispatch(actions.setShowSessionModal(false));
    }

    return(
        <div className="session-modal">
            <Modal close={close}>
                <div className="session-modal-content">
                    <h2 className="session-modal-content-title">{ getLabelFallback('SESSION_MODAL_TITLE') }</h2>
                    <div className="session-modal-content-text">
                        <span>{ getLabelFallback('SESSION_MODAL_TEXT_LINE') }</span>
                    </div>
                    <button className="violet-button" onClick={clickButton}>{ getLabelFallback('SESSION_MODAL_BUTTON_LABEL') }</button>
                </div>
            </Modal>
        </div>
    )
}

export default SessionModal;